import { jsxs as v, jsx as l } from "react/jsx-runtime";
import { clsx as c } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useRef as I, useState as N, useEffect as b } from "react";
import { useIsVisible as x } from "../../utils/use-is-visible.js";
import e from "./roche-animated-words.module.scss.js";
const A = 1400, C = ["red", "orange", "purple", "brand"], y = ({ headline: m, words: o }) => {
  const _ = I(null), [a, u] = N(0), w = x(_), t = o ? o.trim().split(`
`) : [], d = t.length <= 3 && t.length > 1 ? [...t, ...t] : t, i = t.length > 1, h = (r) => {
    const s = r % t.length === t.length - 1 ? "animated-words__word--effect" : `animated-words__word--${C[r % t.length % t.length]}`;
    if (!i)
      return c(e["animated-words__word"], e[s], {
        [e["animated-words__word--active"]]: !0
      });
    const n = d.length, p = r === a, f = r === (a - 1 + n) % n, g = r === (a + 1 + n) % n;
    return c(e["animated-words__word"], e[s], {
      [e["animated-words__word--active"]]: p,
      [e["animated-words__word--previous"]]: f,
      [e["animated-words__word--next"]]: g
    });
  };
  return b(() => {
    if (i && w) {
      const r = setInterval(() => {
        u((s) => (s + 1) % d.length);
      }, A);
      return () => clearInterval(r);
    }
  }, [t, w]), /* @__PURE__ */ v(
    "h2",
    {
      ref: _,
      className: c(e["animated-words"], {
        [e["animated-words--animated"]]: i
      }),
      "aria-label": `${m} ${o.replaceAll(`
`, ", ")}`,
      children: [
        /* @__PURE__ */ l("span", { className: e["animated-words__headline"], children: m }),
        /* @__PURE__ */ l("div", { className: e["animated-words__text-container"], children: d.map((r, s) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
          /* @__PURE__ */ l("span", { className: h(s), children: r }, s)
        )) })
      ]
    }
  );
};
export {
  y as RocheUIAnimatedWords
};
